export default __webpack_public_path__ + "static/media/cert-student-cpttm.143af0f6.jpg";